const config = {
	domain: process.env.GATSBY_OKTA_DOMAIN,
	issuer: process.env.GATSBY_OKTA_ISSUER,
	clientId: process.env.GATSBY_OKTA_CLIENT_ID,
	scopes: ["openid", "profile", "brand:wvi"],
	responseType: ["token", "id_token"],
	pkce: true,
	disableHttpsCheck: process.env.GATSBY_OKTA_DISABLE_HTTPS_CHECK,
};

const userAccountRoutingPaths = {
	en: {
		base: "user-account",
		callback: "login/callback",
		login: "login",
		profile: "manage-my-vacations",
		agent: "agent",
		register: "/en-ca/rewards/join",
		account: "/en-ca/account",
	},
	fr: {
		base: "compte-utilisateur",
		callback: "login/callback",
		login: "se-connecter",
		profile: "gerer-mes-vacances",
		agent: "agent",
		register: "/fr-ca/recompenses/join",
		account: "/fr-ca/account",
	},
};

// Fallback images
const productImages = {
	hotel:
		"https://assets.sunwingtravelgroup.com/image/upload/f_auto,q_auto/WestJet/DIGITAL/VWQ/PROFILE/products/hotel.jpg",
};

module.exports = {
	config,
	userAccountRoutingPaths,
	productImages,
};
